import { t } from 'ttag'

export const MODULES_FIELD = 'modules'
export const ABILITY_TEST_FIELD = 'ability'
export const PERSONALITY_TEST_FIELD = 'personality'
export const INTERVIEW_MODULE_FIELD = 'interview'
export const INTERVIEW_TEMPLATE_FIELD = 'template'

export const getContent = () => ({
  [ABILITY_TEST_FIELD]: {
    description: t`Mental ability is connected to how quickly one learns and adapts to new situations. This gives us a valuable indication of a person’s ability to plan, think abstractly, and understand complex ideas. A candidate with high mental ability is more likely to learn job-related knowledge faster. The link between general mental ability and job performance has been confirmed by over a thousand empirical studies.`,
    label: t`Ability Test`,
    isDisabled: true,
  },
  [PERSONALITY_TEST_FIELD]: {
    description: t`Personality factors have a connection with how successful the candidate’s education and training will be and how structured the candidate will work. Personality factors can provide valuable information about, amongst others, the candidate’s performance and productivity, social interaction with others, and turnover intention. `,
    label: t`Personality Test`,
    isDisabled: true,
  },
  [INTERVIEW_MODULE_FIELD]: {
    description: t`The interview can have great predictive value for future candidate performance, if it is carried out in a structured manner. The interview module will help to maintain a structured interview process by, amongst other things, giving you suggestions for competency-based questions and facilitating individual assessment of candidates.`,
    label: t`Interview Module`,
    isDisabled: false,
  },
})

export const getFields = () => [
  { [ABILITY_TEST_FIELD]: true, name: ABILITY_TEST_FIELD },
  { [PERSONALITY_TEST_FIELD]: true, name: PERSONALITY_TEST_FIELD },
  { [INTERVIEW_MODULE_FIELD]: false, name: INTERVIEW_MODULE_FIELD },
  { interest: false, name: 'interest' },
]

export const getDefaultValues = () => ({
  [MODULES_FIELD]: getFields(),
  [INTERVIEW_TEMPLATE_FIELD]: null,
})
